import React from 'react'
import {
  agentScopeSuffix,
  useAgentName,
  useMessagesPerDay,
  useMessagesPerWeek,
} from '../../hooks/analytics/useAnalytics'
import { AgentFilter } from '../../types/analyticsTypes'
import GranularitySwitchChart from './GranularitySwitchChart'

interface Props {
  agentId: AgentFilter
}

const MessagesChart: React.FC<Props> = ({ agentId }) => {
  const agentName = useAgentName(agentId)
  const messagesPerWeek = useMessagesPerWeek(agentId)
  const messagesPerDay = useMessagesPerDay(agentId)

  return (
    <GranularitySwitchChart
      title={`Messages${agentScopeSuffix(agentName)}`}
      valueLabel='User messages'
      daily={{
        isLoading: messagesPerDay.isLoading,
        isError: messagesPerDay.isError,
        points: (messagesPerDay.data ?? []).map(point => ({
          day: point.day,
          value: point.messages,
        })),
      }}
      weekly={{
        isLoading: messagesPerWeek.isLoading,
        isError: messagesPerWeek.isError,
        points: (messagesPerWeek.data ?? []).map(point => ({
          day: point.week_start,
          value: point.messages,
        })),
      }}
      dailySubtitle={days =>
        `User messages sent per day (last ${days} days). Today is partial.`
      }
      weeklySubtitle={weeks =>
        `User messages sent per week (last ${weeks} weeks). The current week is partial.`
      }
    />
  )
}

export default MessagesChart
